import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import HowItWorks from "../components/HowItWorks";
import CustomerBenefits from "../components/CustomerBenefits";
import BusinessBenefits from "../components/BusinessBenefits";
import Testimonials from "../components/Testimonials";
import DownloadSection from "../components/DownloadSection";
import RegistrationForm from "../components/RegistrationForm";
import Footer from "../components/Footer";

const LandingPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: isLoaded ? 1 : 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-background"
    >
      <Header />
      <main>
        <HeroSection />
        <HowItWorks />
        <CustomerBenefits />
        <BusinessBenefits />
        <Testimonials />
        <DownloadSection />
        <RegistrationForm />
      </main>
      <Footer />
    </motion.div>
  );
};

export default LandingPage;
